var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cookies"},[_c('p',[_vm._v("This site uses cookies to ensure you get the best experience.")]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('a',[_vm._v("More Info Pls")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.giveConsent()}}},[_vm._v("OK")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a29443","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cookies.vue
// module id = null
// module chunks = 